import { Entity } from '../common'
import { SecurityProfile } from './security-profile'

/**
 * Avatar representing an {@link Account}.
 * An account has at least one, but can have more avatars.
 */
export class Avatar extends Entity {
  constructor (data = {}) {
    super(data)
    this.assign({
      ...data
    })
  }

  /**
   * Normalizes the assigned data
   */
  normalize () {
    super.normalize()
    this.securityProfile = this.cast(this.securityProfile, SecurityProfile)
    this.isEnabled = Boolean(this.isEnabled)
  }

  /**
   * Indicates a default avatar
   * @type {Boolean}
   */
  isDefault

  /**
   * Name of the security profile assigned to the avatar
   * @type {String}
   */
  securityProfileName

  /**
   * Security profile assigned to the avatar
   * @type {SecurityProfile}
   * @description RUNTIME PROPERTY
   */
  securityProfile

  /**
   * Avatar's first name
   * @type {String}
  */
  firstName

  /**
  * Avatar's last name
  * @type {String}
  */
  lastName

  /**
   * Avatar's organization name,
   * if avatar represents an organization, company or institution
   * @type {String}
   */
  organization

  /**
   * Full name, often overridden in descendants
   * to include things such as profile name etc.
   * @type {String}
   */
  get fullName () {
    return [this.organization, this.firstName, this.lastName]
      .filter(p => p?.trim())
      .join(' ')
  }

  /**
   * Checks whether avatar is assigned to the specified security profile
   * @param {String} name Security profile name
   * @returns {Boolean}
   */
  hasSecurityProfile (name) {
    if (!name) return false
    // The security profile object is not serialized, so on the client side only its name is available
    return this.securityProfileName === name || this.securityProfile?.name === name
  }

  /**
  * Indicates whether the avatar is enabled
  * @type {Boolean}
  */
  isEnabled

  /**
   * Overrides serialization to prevent serializing of certain
   * runtime-only properties
   * @returns {Object}
   */
  toJSON () {
    const result = { ...this }
    delete result.securityProfile
    return result
  }
}
